let url = 'https://makegayfriends.com/api/v1/'
let hybrid_user_url = process.env.REACT_APP_MKGF_MASTODON_API+'/user/'

export const getAccounts = async (offset, local, token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(url+'directory?offset='+offset+"&local="+local, { headers });
    const data = await response.json();
    return data
}

export const getSingleAccount = async (id, token) => {
    const headers = { 'Authorization': 'Bearer '+token }

    const account_response = await fetch(url+'accounts/'+id, { headers });
    const account_data = await account_response.json();

    let mastodon_id = account_data?.id
    let mastodon_data = {}
    try {
        const mastodon_response = await fetch(hybrid_user_url+mastodon_id, { headers });
        if (mastodon_response.ok) mastodon_data = await mastodon_response.json();
    } catch {}

    return {account:account_data, mastodon:mastodon_data}
}

export const getStatuses = async (id, token, max_id) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const fetch_url = max_id ? url+'accounts/'+id+'/statuses?exclude_replies=true&limit=0&max_id='+max_id : url+'accounts/'+id+'/statuses'
    const response = await fetch(fetch_url, { headers });
    const data = await response.json();
    return data
}

export const getAccount = async (id, token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const account_response = await fetch(url+'accounts/'+id, { headers });
    const data = await account_response.json();
    return data
}

export const searchAccounts = async (query, token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(url+'accounts/search?q='+encodeURIComponent(query)+'&limit=8', { headers });
    const data = await response.json();
    return data
}

// Tells us whether we can privately message someone: Mastodon accounts commonly
// only accept DMs from people they follow, so `followed_by` (they follow us
// back) is what actually determines whether a direct message will reach them.
export const getRelationship = async (id, token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(url+'accounts/relationships?id[]='+id, { headers });
    const data = await response.json();
    return data?.[0]
}

// Nearby accounts come from our own server (which knows physical location),
// then get hydrated into full Mastodon account objects one-by-one via getAccount
// so the result matches the same shape the Mastodon directory already returns.
export const getNearbyAccounts = async ({ token, mastodon_id, latitude, longitude, miles, skip, limit }) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const params = new URLSearchParams({
        mastodon_id: mastodon_id ?? '',
        latitude: latitude ?? '',
        longitude: longitude ?? '',
        miles: miles ?? '',
        skip: skip ?? 0,
        limit: limit ?? 40,
    })
    const response = await fetch(hybrid_user_url+'nearby?'+params.toString(), { headers });
    const data = await response.json();
    const accounts = await Promise.all(
        (data?.mastodon_ids ?? []).map(id => getAccount(id, token))
    );
    return accounts.filter(account => account?.id)
}

export const updateSingleAccount = async ({body, token}) => {
    const { ...allValues } = body
    let formData = new FormData()
    Object.keys(allValues).forEach(key => { 
        formData.append([key], allValues[key]);
    })
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(url+'accounts/update_credentials', { method:"PATCH", headers, body:formData });
    const data = await response.json();
    return data
}

export const updateAvatar = async ({image, token}) => {
    let formData = new FormData()
    formData.append('avatar', image);
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(url+'accounts/update_credentials', { method:"PATCH", headers, body:formData });
    const data = await response.json();
    return data
}

export const followManager = async ({token, follow, id}) => {
    const headers = { 'Authorization': 'Bearer '+token }
    let fetch_url = follow ? url+'accounts/'+id+'/follow' : url+'accounts/'+id+'/unfollow'
    const response = await fetch(fetch_url, { method:"POST", headers });
    const data = await response.json();
    return data
}

export const getFollowingList = async (id, token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(url+'accounts/'+id+'/following', { headers });
    const data = await response.json();
    return data
}